module.exports = __webpack_public_path__ + "img/facesheet.6a6441ee.png";